import { Action } from 'redux';
export const GET_CREATE_LOGIN_PAGE = 'user-account-pages/GET_CREATE_LOGIN_PAGE';
export const SET_CREATE_LOGIN_PAGE = 'user-account-pages/SET_CREATE_LOGIN_PAGE';
export const UPDATE_CREATE_LOGIN_PAGE = 'user-account-pages/UPDATE_CREATE_LOGIN_PAGE';
export const CREATE_CREATE_LOGIN_PAGE = 'CREATE_CREATE_LOGIN_PAGE';
/** get create login page  */
export interface GetCreateLoginPageAction extends Action<typeof GET_CREATE_LOGIN_PAGE> {
  payload: any;
}

export const getCreateLoginPage = (data: any): GetCreateLoginPageAction => ({
  payload: data,
  type: GET_CREATE_LOGIN_PAGE,
});

/** set create login page  */
export interface SetCreateLoginPageAction extends Action<typeof SET_CREATE_LOGIN_PAGE> {
  payload: any;
}

export const setCreateLoginPage = (data: any): SetCreateLoginPageAction => ({
  payload: data,
  type: SET_CREATE_LOGIN_PAGE,
});

/** update create login page  */
export interface UpdateCreateLoginPageAction extends Action<typeof UPDATE_CREATE_LOGIN_PAGE> {
  payload: any;
}

export const updateCreateLoginPage = (data: any): UpdateCreateLoginPageAction => ({
  payload: data,
  type: UPDATE_CREATE_LOGIN_PAGE,
});
